// extracted by mini-css-extract-plugin
export default {"section":"VideoSection_section__yYDIT","container":"VideoSection_container__2bzlj","videoWrapper":"VideoSection_videoWrapper__iXSmJ"};